<template>
  <EmNavigationDrawerMobile v-if="display.smAndDown" v-bind="$attrs" />
  <EmNavigationDrawerWeb v-else />
</template>
<script setup>
import { useDisplay } from 'vuetify'
const display = ref(useDisplay())
</script>
